
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signed-authorizations",
      function () {
        return require("private-next-pages/signed-authorizations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signed-authorizations"])
      });
    }
  